import { render, staticRenderFns } from "./NavigationBar.vue?vue&type=template&id=2dc45ae1&scoped=true"
import script from "./NavigationBar.vue?vue&type=script&lang=js"
export * from "./NavigationBar.vue?vue&type=script&lang=js"
import style0 from "./NavigationBar.vue?vue&type=style&index=0&id=2dc45ae1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc45ae1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dc45ae1')) {
      api.createRecord('2dc45ae1', component.options)
    } else {
      api.reload('2dc45ae1', component.options)
    }
    module.hot.accept("./NavigationBar.vue?vue&type=template&id=2dc45ae1&scoped=true", function () {
      api.rerender('2dc45ae1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/core/NavigationBar.vue"
export default component.exports